module.exports = __webpack_public_path__ + "static/img/videoFile.8b2406f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/classroomObservation/videoFile.svg
// module id = m1dC
// module chunks = 4